import Swiper from 'swiper'
import { Mousewheel, Navigation, Scrollbar } from 'swiper/modules'



export default function () {
	document.addEventListener('DOMContentLoaded', function () {
		const productsSliderEls = document.querySelectorAll('.section-products-carousel-slider')
		if (productsSliderEls) {
			productsSliderEls.forEach((productsSliderEl) => {
				const sectionEl = productsSliderEl.closest('.section-products-carousel')
				if (sectionEl) {
					const id = sectionEl.id
					let config = {
						modules: [Navigation, Mousewheel, Scrollbar],
						slidesPerView: 1,
						centeredSlides: false,
						spaceBetween: 20,
						navigation: {
							prevEl: `#${id} .prev`,
							nextEl: `#${id} .next`,
							disabledClass: 'btn-disabled',
						},
						breakpoints: {
							768: {
								slidesPerView: 2,
							},
							1024: {
								slidesPerView: 3,
							},
							1400: {
								slidesPerView: 4,
							},
						},
						mousewheel: {
							enabled: true,
							forceToAxis: true,
						},
						scrollbar: {
							el: `#${id} .swiper-scrollbar`,
						},
						on: {
							afterInit(swiperInstance) {
								const totalSlides = swiperInstance.slides.length
								const currentSlidesPerView = getCurrentSlidesPerView(swiperInstance)

								if (totalSlides <= currentSlidesPerView) {
									const prev = sectionEl.querySelector('.prev') as HTMLElement
									const next = sectionEl.querySelector('.next') as HTMLElement
									prev?.classList.add('hidden')
									next?.classList.add('hidden')
								}
							},
						},
					}
					if(sectionEl.classList.contains('section-products-carousel--blog')) {
						config = {
							...config,
							slidesPerView: 1,
							breakpoints: {
								390: {
									slidesPerView: 1.15,
								},
								575: {
									slidesPerView: 1.5,
								},
								768: {
									slidesPerView: 2.25,
								},

							},
						}
					}

					new Swiper(productsSliderEl as HTMLElement, config)
				}
			})
		}
	})
}

function getCurrentSlidesPerView(swiper: Swiper): number {
	const breakpoints = swiper.params.breakpoints || {}
	const windowWidth = window.innerWidth

	let matched = swiper.params.slidesPerView as number

	for (const bp in breakpoints) {
		if (windowWidth >= parseInt(bp)) {
			const config = breakpoints[bp]
			if (typeof config === 'object' && 'slidesPerView' in config) {
				matched = config.slidesPerView as number
			}
		}
	}
	return matched
}
